import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetClaimableJurisdictionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetClaimableJurisdictionsQuery = { __typename?: 'query_root', jurisdictions: Array<{ __typename?: 'jurisdictions', id: any, name: string, city?: string | null, county?: string | null, state: string }> };


export const GetClaimableJurisdictionsDocument = gql`
    query GetClaimableJurisdictions {
  jurisdictions(order_by: {name: asc}) {
    id
    name
    city
    county
    state
  }
}
    `;

/**
 * __useGetClaimableJurisdictionsQuery__
 *
 * To run a query within a React component, call `useGetClaimableJurisdictionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClaimableJurisdictionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClaimableJurisdictionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClaimableJurisdictionsQuery(baseOptions?: Apollo.QueryHookOptions<GetClaimableJurisdictionsQuery, GetClaimableJurisdictionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClaimableJurisdictionsQuery, GetClaimableJurisdictionsQueryVariables>(GetClaimableJurisdictionsDocument, options);
      }
export function useGetClaimableJurisdictionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClaimableJurisdictionsQuery, GetClaimableJurisdictionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClaimableJurisdictionsQuery, GetClaimableJurisdictionsQueryVariables>(GetClaimableJurisdictionsDocument, options);
        }
export function useGetClaimableJurisdictionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClaimableJurisdictionsQuery, GetClaimableJurisdictionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClaimableJurisdictionsQuery, GetClaimableJurisdictionsQueryVariables>(GetClaimableJurisdictionsDocument, options);
        }
export type GetClaimableJurisdictionsQueryHookResult = ReturnType<typeof useGetClaimableJurisdictionsQuery>;
export type GetClaimableJurisdictionsLazyQueryHookResult = ReturnType<typeof useGetClaimableJurisdictionsLazyQuery>;
export type GetClaimableJurisdictionsSuspenseQueryHookResult = ReturnType<typeof useGetClaimableJurisdictionsSuspenseQuery>;
export type GetClaimableJurisdictionsQueryResult = Apollo.QueryResult<GetClaimableJurisdictionsQuery, GetClaimableJurisdictionsQueryVariables>;